<template>
  <div class="right">
    <div class="title">基本信息</div>
    <el-divider></el-divider>
    <div class="box1">
      <div class="box1_info">
        <div class="box1_info_title">{{ detail.name }}</div>
        <div>类型：{{ detail.type === 'AC' ? '交流充电桩' : '直流充电桩' }}</div>
        <div>型号：{{ detail.name }}</div>
        <div>站点：{{ detail.parent }}</div>
        <div>单价：{{ detail.name }}</div>
      </div>
      <div class="box1_status">
        <div>充电桩状态</div>
        <div class="box1_status_type">充电中</div>
      </div>
      <div class="box1_count">
        <div class="box1_count_item">
          <div>日充电量</div>
          <div class="num">13.3kWh</div>
        </div>
        <div class="box1_count_item">
          <div>日充电量</div>
          <div class="num">1次</div>
        </div>
        <div class="box1_count_item">
          <div>日充电量</div>
          <div class="num">3.98h</div>
        </div>
      </div>
    </div>
    <div class="box2">
      <div class="box2_left">
        <img v-show="detail.type === 'DC'" src="../../../assets/img/icon100.png" alt="">
        <img v-show="detail.type === 'AC'" src="../../../assets/img/icon101.png" alt="">
      </div>
      <div class="box2_right">
        <div class="box2_tag">
          <!--          直流电-->
          <div v-show="detail.type === 'DC'" class="box2_tag_item"
               v-for="item in tags"
               :key="item.value"
          >
            <span class="box2_tag_item_span">{{ item.label }}</span>
            <table border="1" cellpadding="0" cellspacing="0">
              <tr>
                <td class="table_label">充电电压</td>
                <td class="table_value">13.3V</td>
                <td class="table_label">充电电流</td>
                <td class="table_value">13.3A</td>
              </tr>
              <tr>
                <td class="table_label">已充电量</td>
                <td class="table_value">13.3kWh</td>
                <td class="table_label">剩余电量</td>
                <td class="table_value">60%</td>
              </tr>
              <tr>
                <td class="table_label">剩余功率</td>
                <td class="table_value">7kW</td>
                <td class="table_label"></td>
                <td class="table_value"></td>
              </tr>
            </table>
          </div>
          <!--          交流电-->
          <div v-show="detail.type === 'AC'" class="box2_tag_item2">
            <span class="box2_tag_item_span">插枪一</span>
            <table border="1" cellpadding="0" cellspacing="0">
              <tr>
                <td class="table_label">A相电压</td>
                <td class="table_value">13.3V</td>
                <td class="table_label">A相电流</td>
                <td class="table_value">13.3A</td>
                <td class="table_label">已充电量</td>
                <td class="table_value">13.3A</td>
              </tr>
              <tr>
                <td class="table_label">B相电压</td>
                <td class="table_value">13.3V</td>
                <td class="table_label">B相电流</td>
                <td class="table_value">13.3A</td>
                <td class="table_label">剩余电量</td>
                <td class="table_value">13.3A</td>
              </tr>
              <tr>
                <td class="table_label">C相电压</td>
                <td class="table_value">13.3V</td>
                <td class="table_label">C相电流</td>
                <td class="table_value">13.3A</td>
                <td class="table_label">实时功率</td>
                <td class="table_value">13.3A</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="box3">
      <div class="box3_title">
        <div class="title">
          <div v-for="item in tags2" :key="item.value"
               class="title_item"
               :style="`color: ${item.value === active2 ? '#0d94ff' : '#333'}`"
               @click="active2 = item.value"
          >
            {{ item.label }}
          </div>
        </div>
        <div>
          <el-button type="primary">搜 索</el-button>
          <el-button v-show="detail.type === 'AC'" type="primary">导 出</el-button>
        </div>
      </div>
      <div class="box3_search">
        <el-date-picker
            style="width: 33.33%"
            v-model="from.date"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right">
        </el-date-picker>
        <div style="width: 10rem; height: 10rem"></div>
        <el-select v-show="active2 === 0" v-model="from.state" style="width: 33.33%" placeholder="交易状态">
          <option value=""></option>
        </el-select>
        <div style="width: 10rem; height: 10rem"></div>
        <el-input v-show="active2 === 0" v-model="from.keyword" style="width: 33.33%"
                  placeholder="订单号/联系电话/用户名称"></el-input>
        <el-input v-show="active2 === 1" v-model="from.content" style="width: 33.33%" placeholder="故障内容"></el-input>
      </div>
      <div class="box3_table">
        <Table :active2="active2"></Table>
      </div>
      <el-pagination
          style="text-align: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="400">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Table from "./table.vue"

export default {
  name: "RightContent",
  components: {
    Table
  },
  props: ["detail"],
  data() {
    return {
      from: {
        date: [],
        state: '',
        keyword: '',
        content: ''
      },
      value2: [],
      active: 0,
      active2: 0,
      tags: [
        {
          value: 0,
          label: '插枪1'
        },
        {
          value: 1,
          label: '插枪2'
        }
      ],
      tags2: [
        {
          value: 0,
          label: '充电记录'
        },
        {
          value: 1,
          label: '历史事件'
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
.right {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  .title {
    height: 19rem;
    line-height: 19rem;
    border-left: 5rem solid #0d94ff;
    padding-left: 6rem;
    display: flex;
  }

  .el-divider {
    margin: 6rem 0 16rem 0;
  }

  .box1 {
    width: 100%;
    height: 24%;
    //background-color: pink;
    margin-bottom: 20rem;
    display: flex;

    .box1_info {
      width: 27%;
      height: 100%;
      //background-color: #768;
      margin-right: 10rem;
      padding-bottom: 12rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      div {
        font-size: 18px;
        //font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
      }

      & div:nth-child(1) {
        font-size: 24px;
        //font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
      }
    }

    .box1_status {
      width: 21%;
      height: 100%;
      margin-right: 10rem;
      background-color: rgba(0, 43, 102, .04);
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .box1_status_type {
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #FFB900;
        margin-top: 10rem;
      }
    }

    .box1_count {
      width: calc(52% - 20rem);
      height: 100%;
      background-color: rgba(0, 43, 102, .04);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .box1_count_item {
        text-align: center;

        .num {
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #0D94FF;
          margin-top: 10rem;
        }
      }
    }
  }

  .box2 {
    width: 100%;
    height: 20.5%;
    //background-color: pink;
    margin-bottom: 22rem;
    display: flex;

    .box2_left {
      width: 91rem;
      height: 100%;
      margin-right: 7rem;
      //border: 1rem solid #E5E5E5;
      display: flex;
      align-items: flex-end;
    }

    .box2_right {
      width: calc(100% - 98rem);

      .box2_tag {
        display: flex;

        .box2_tag_item {
          width: 50%;
          font-weight: bold;

          .box2_tag_item_span {
            display: inline-block;
            font-size: 18px;
            font-family: Source Han Sans CN;
            color: #0D94FF;
            padding-bottom: 10rem;
            border-bottom: 4rem solid #0d94ff;
          }

          table {
            width: 100%;
            height: 100%;
            border: 1rem solid #F2F2F2;

            tr {
              td {
                width: 25%;
                text-align: center;
                border: 1rem solid rgba(0, 0, 0, .12);
              }

              .table_label {
                background: #F5F7F9;
              }

              .table_value {
                font-size: 18rem;
                color: #0d94ff;
                text-align: left;
                padding: 0 10rem;
              }
            }
          }
        }

        .box2_tag_item2 {
          width: 80%;
          font-weight: bold;

          .box2_tag_item_span {
            display: inline-block;
            font-size: 18px;
            font-family: Source Han Sans CN;
            color: #0D94FF;
            padding-bottom: 10rem;
            border-bottom: 4rem solid #0d94ff;
          }

          table {
            width: 100%;
            height: 100%;
            border: 1rem solid #F2F2F2;

            tr {
              td {
                width: calc(100% / 6);
                text-align: center;
                border: 1rem solid rgba(0, 0, 0, .12);
              }

              .table_label {
                background: #F5F7F9;
              }

              .table_value {
                font-size: 18rem;
                color: #0d94ff;
                text-align: left;
                padding: 0 10rem;
              }
            }
          }
        }
      }
    }
  }

  .box3 {
    width: 100%;
    height: 46%;
    //background-color: pink;

    .box3_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 4rem;
    }

    .box3_search {
      display: flex;
      width: 100%;
      margin-bottom: 21rem;
    }

    .box3_table {
      height: 60%;
      overflow-y: auto;
    }

    .title_item {
      cursor: pointer;
      margin-right: 40rem;
    }

    .title_item_active {
      color: #0d94ff;
    }

    .el-button {
      height: 42rem;
      line-height: 42rem;
      padding: 0 32rem;
      font-size: 18rem;
      border-radius: 2rem;
    }
  }
}

</style>